<h1 class="mc-tt">Mis domicilios</h1>
<p class="cd-sub">Podés tener varios y elegir cuál usamos por defecto.</p>

<div class="mc-blk cd-lista">

  <div class="cd-addr" *ngFor="let d of domicilios" [class.pri]="d.esPrincipal">

    <div class="cd-at">
      <b>{{ calle(d.dom) || 'Domicilio sin calle' }}</b>
      <span *ngIf="ubicacion(d.dom)">{{ ubicacion(d.dom) }}</span>

      <div class="cd-tags" *ngIf="d.esPrincipal">
        <span class="cd-tag">Principal</span>
      </div>
    </div>

    <!-- El prototipo tiene acá un boton "Subir su foto" que viene copiado de las
         mascotas. No corresponde a un domicilio, asi que se omite. -->
    <div class="cd-aa">
      <button class="cd-lnk" *ngIf="!d.esPrincipal" (click)="markAsPrincipal(d.indice)">
        Hacer principal
      </button>
      <button class="cd-lnk" (click)="goToEdit(d.indice)">Editar</button>
      <button class="cd-lnk q" (click)="delete(d.indice)">Eliminar</button>
    </div>

  </div>

  <div class="cd-vacio" *ngIf="!hayDomicilios && !isLoading">
    <mat-icon>home</mat-icon>
    <span>Todavía no cargaste ningún domicilio.</span>
  </div>

  <button class="cd-btn-gh" (click)="agregar()">Agregar un domicilio</button>

</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
